(function(){
    'use strict'

    angular
    .module('app.procesosMasivos')
    .controller('ProcesoMasivoDetalle', ProcesoMasivoDetalle);

    ProcesoMasivoDetalle.$inject = ['$scope', '$animationsSrv', '$routeParams', 'ProcesosMasivosService', 'logger'];

    function ProcesoMasivoDetalle($scope, $animationsSrv, $routeParams, ProcesosMasivosService, logger) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.companiaId = $routeParams.companiaId ? $routeParams.companiaId : '';
        vm.procesoId = $routeParams.encabezadoId ? $routeParams.encabezadoId : 0;
        
        vm.encabezado = {};
        vm.detalle = [];

        vm.title = 'Proceso Ejecutado Detalle';

        getEncabezado();
        getAll();

        function getEncabezado(){

            if(vm.companiaId && vm.procesoId){
                var promise = ProcesosMasivosService.getEncabezadoProceso(vm.procesoId)
                .then(function(encabezado){
                    vm.encabezado = encabezado;
                })
                .catch(function(error){
                    logger.error('Error al obtener los datos del encabezado.');
                }); 
            }
            else{
                logger.error('Parametros invalidos.');
            }
        
        };

        function getAll(){

            if(vm.companiaId && vm.procesoId){
                var promise = ProcesosMasivosService.getDetalle(vm.procesoId)
                .then(function(detalle){
                    vm.detalle = detalle;
                })
                .catch(function(error){
                    logger.error('Error al obtener los datos del detalle.');
                }); 
            }
            else{
                logger.error('Parametros invalidos.');
            }
        
        };

    }
})();